import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1>ABOUT US</h1>
        <p className="intro-text">
          baplehollow is a Hong Kong-based online store for relaxed clothing,
          useful accessories and warm, practical homeware. We select pieces for
          their comfortable materials, simple details and everyday usefulness.
        </p>

        <div className="image-grid">
          <div className="image-item">
            <img src="/assets/about/about-1.webp" alt="baplehollow online studio in Hong Kong" />
          </div>
          <div className="image-item">
            <img src="/assets/about/about-2.webp" alt="Checking the fabric and seams of a linen shirt" />
          </div>
          <div className="image-item">
            <img src="/assets/about/about-3.webp" alt="Warm natural homeware styling" />
          </div>
          <div className="image-item">
            <img src="/assets/about/about-4.webp" alt="Preparing a baplehollow order" />
          </div>
        </div>

        <div className="footer-info">
          <p>
            baplehollow is owned and operated by Hong Kong Ruijingsheng Trading
            Co., Limited.
          </p>
          <p>
            Business address: RM 12, UNIT 12A, 13/F, BLOCK 1, CAMEL PAINT
            BUILDING, 62 HOI YUEN ROAD, KWUN TONG, HONG KONG.
          </p>
          <p>
            We aim to show every item clearly, describe it accurately and make
            support easy to reach before and after an order.
          </p>
          <p>Contact us at model@baplehollow.online.</p>
        </div>
      </div>
    </div>
  );
}

export default About;
